import { normalizeWhatsAppNumber } from '../../utils/whatsappFormatter';

export const customerUploader = (data) => {
  const formdata = new FormData();

  formdata.append('name', data.name);
  formdata.append('email', data.email);
  formdata.append('whatsapp_number', normalizeWhatsAppNumber(data.whatsapp_number || ''));
  formdata.append('address', data.address || '');
  formdata.append('area', data.area || '');
  formdata.append('landmark', data.landmark || '');
  formdata.append('remarks', data.remarks || '');
  formdata.append('status', data.active != null ? data.active : true);

  return formdata;
}
